import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const NewNote = ({ newNoteText, setNewNoteText, creatingNoteOperation, onCreateNote }) => {
    const quillRef = useRef(null);

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['clean']
        ]
    };

    const formats = [
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet'
    ];

    const handleChange = useCallback((content) => {
        setNewNoteText(content);
    }, [setNewNoteText]);

    return (
        <div className="new-note-section">
            <div className="new-note-form">
                <div className="new-note-header">
                    <div className="user-avatar">
                        <i className="fa fa-user-circle"></i>
                    </div>
                    <div className="new-note-content">
                        <div>
                            <ReactQuill 
                                ref={quillRef}
                                className="new-note-quill" 
                                theme="snow"
                                value={newNoteText} 
                                onChange={handleChange}
                                modules={modules}
                                formats={formats}
                                placeholder="Add a note..."
                            />
                        </div>
                        <div className="new-note-actions">
                            {creatingNoteOperation ? (
                                <Spinner 
                                    as="span" 
                                    animation="grow" 
                                    size="sm" 
                                    aria-hidden="true" 
                                />
                            ) : (
                                <Button 
                                    variant='primary' 
                                    size='sm' 
                                    onClick={onCreateNote}
                                    className="post-note-btn"
                                >
                                    Post
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

NewNote.propTypes = {
    newNoteText: PropTypes.string.isRequired,
    setNewNoteText: PropTypes.func.isRequired,
    creatingNoteOperation: PropTypes.bool.isRequired,
    onCreateNote: PropTypes.func.isRequired
};

export default NewNote; 